define.alias("shared/components/shared/social/instagram-connect-modal", "calendar/components/shared/social/instagram-connect-modal");